/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid, Button } from "@chakra-ui/react";
import DevelopmentTable from "views/admin/dataTables/components/DevelopmentTable";
import CheckTable from "views/admin/dataTables/components/CheckTable";
import ColumnsTable from "views/admin/dataTables3/components/ColumnsTable";
import ComplexTable from "views/admin/dataTables/components/ComplexTable";
import {
  columnsDataDevelopment,
  columnsDataCheck,
  columnsDataColumns,
  columnsDataComplex,
} from "views/admin/dataTables/variables/columnsData";
import tableDataDevelopment from "views/admin/dataTables/variables/tableDataDevelopment.json";
import tableDataCheck from "views/admin/dataTables/variables/tableDataCheck.json";
import tableDataColumns from "views/admin/dataTables/variables/tableDataColumns.json";
import tableDataComplex from "views/admin/dataTables/variables/tableDataComplex.json";
import OpenBilling from './components/OpenBilling'
import React, { useState } from "react";
import { 
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Flex,
  Text,
  useToast
} from "@chakra-ui/react";
import { commonFetch } from '@/utils/util'

export default function Settings() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
  const toast = useToast()

  const [payData, setPayData] = useState(null)

  const onDetail = (row) => {
    commonFetch({
      url: `/api/consumption/pay/${row.payOrderId}`,
      method: 'get',
    }, toast).then(res => {
      setPayData(res)
      onOpen()
    })
  }

  // Chakra Color Mode
  return (
    <>
      <Box pt={{ base: "130px", md: "100px", xl: "100px" }}>
        <OpenBilling />
        <SimpleGrid
          mb='20px'
          // columns={{ sm: 1, md: 2 }}
          spacing={{ base: "20px", xl: "20px" }}>
          {/* <DevelopmentTable
            columnsData={columnsDataDevelopment}
            tableData={tableDataDevelopment}
          />
          <CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} /> */}
          <ColumnsTable
            columnsData={columnsDataColumns}
            tableData={tableDataColumns}
            onDetail={onDetail}
          />
          {/* <ComplexTable
            columnsData={columnsDataComplex}
            tableData={tableDataComplex}
          /> */}
        </SimpleGrid>
      </Box>
      <Drawer
        size="lg"
        isOpen={isOpen}
        placement="right"
        finalFocusRef={btnRef}
        onClose={onClose}
      >
        <DrawerOverlay />
        {
          !!payData && <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>订单详情</DrawerHeader>
            <DrawerBody>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>服务商号：{payData.isvNo}</Text>
                </Box>
                <Box flex={1}>
                  <Text>支付订单号：{payData.payOrderId}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>商户号：{payData.mchNo}</Text>
                </Box>
                <Box flex={1}>
                  <Text>商户订单号：{payData.mchOrderNo}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>商户名称：{payData.mchName}</Text>
                </Box>
                <Box flex={1}>
                  <Text>应用APPID：{payData.appId}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Flex flex={1} align={'center'}>
                  <Box>
                    <Text>订单状态：</Text>
                  </Box>
                  <Box bg={
                    {
                      0: 'gray.500',
                      1: 'yellow.500',
                      2: 'green.500',
                      3: 'red.500',
                      4: 'gray.500',
                      5: 'gray.500',
                      6: 'gray.500',
                    }[payData.state] || 'gray.500'
                  } textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                    <Text color={'#fff'} fontSize="sm" fontWeight="700">
                    {
                      {
                        0: '订单生成',
                        1: '支付中',
                        2: '支付成功',
                        3: '支付失败',
                        4: '已撤销',
                        5: '已退款',
                        6: '订单关闭',
                      }[payData.state] || '未知'
                    }
                    </Text>
                  </Box>
                </Flex>
                <Flex flex={1} align={'center'}>
                  <Box>
                    <Text>支付金额：</Text>
                  </Box>
                  <Box bg="green.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                    <Text color={'#fff'} fontSize="sm" fontWeight="700">
                      {payData.amount/100}
                    </Text>
                  </Box>
                </Flex>
              </Flex>
              <Flex mb="15px">
                <Flex flex={1} align={'center'}>
                  <Box>
                    <Text>手续费：</Text>
                  </Box>
                  <Box bg="pink.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                    <Text color={'#fff'} fontSize="sm" fontWeight="700">
                      {payData.actualChangeBalance || 0}
                    </Text>
                  </Box>
                </Flex>
                <Box flex={1}>
                  <Text>商家费率：{(payData.mchFeeRate*100).toFixed(2)}%</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>支付错误码：{payData.errCode}</Text>
                </Box>
                <Box flex={1}>
                  <Text>支付错误描述：{payData.errMsg}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>订单失效时间：{payData.expiredTime}</Text>
                </Box>
                <Box flex={1}>
                  <Text>支付成功时间：{payData.successTime}</Text>
                </Box>
              </Flex>
              <Flex mb="20px">
                <Box flex={1}>
                  <Text>创建时间：{payData.createdAt}</Text>
                </Box>
                <Box flex={1}>
                  <Text>更新时间：{payData.updatedAt}</Text>
                </Box>
              </Flex>

              <Box height={'1px'} w={"100%"} bg="gray.200" mb={"20px"}></Box>

              <Flex mb="15px">
                <Box flex={1}>
                  <Text>商品标题：{payData.subject}</Text>
                </Box>
                <Box flex={1}>
                  <Text>商品描述：{payData.body}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>接口代码：{payData.ifCode}</Text>
                </Box>
                <Box flex={1}>
                  <Text>货币代码：{payData.ifCode}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>支付方式：{payData.wayCode}</Text>
                </Box>
                <Box flex={1}>
                  <Text>客户端IP：{payData.clientIp}</Text>
                </Box>
              </Flex>
              <Flex mb="15px">
                <Box flex={1}>
                  <Text>用户标识：{payData.channelUser}</Text>
                </Box>
                <Box flex={1}>
                  <Text>渠道订单号：{payData.channelOrderNo}</Text>
                </Box>
              </Flex>
            </DrawerBody>
            <DrawerFooter>
              {/* <Button variant="outline" mr={3} onClick={onClose}>
                Cancel
              </Button> */}
              <Button colorScheme="brand" onClick={onClose}>确定</Button>
            </DrawerFooter>
          </DrawerContent>
        }
      </Drawer>
    </>
  );
}
